import { ModalToFilterUserLocation } from '../../components/pagesComponents/mainPage/modalToFilterUserLocation'
import { SectorsAndBusiness } from '../../components/pagesComponents/mainPage/SectorsAndBusiness'
import { Header } from '../../components/pagesComponents/mainPage/header'
import { FirstSection } from '../../components/pagesComponents/mainPage/FirstSection'
import { MainLoader } from '../../components/loaders/mainLoader'
import { useEffect, useState } from 'react'
import { api } from '../../services/api'
import { toast } from 'react-toastify'

import { Container, Content } from './style'


export function Main() {
  const [sectors, setSectors] = useState([])
  const [business, setBusiness] = useState([])
  const [nextPage, setNextPage] = useState(null)
  const [sectorSelected, setSectorSelected] = useState(0)
  const [loadingMoreBusiness, setLoadingMoreBusiness] = useState(false)
  const [isLoading, setIsLoading] = useState(
    localStorage.getItem('@Inoveclube:location') ? true : false
  )
  const [modalToFilterUserLocationOpen, setModalToFilterUserLocationOpen] = useState(
    localStorage.getItem('@Inoveclube:location') ? false : true
  )

  let currentLocation = JSON.parse(localStorage.getItem('@Inoveclube:location'))?.idCity


  async function fetchMoreBusiness() {
    setLoadingMoreBusiness(true)
    try {
      await api.get(`/getAllBusiness/${currentLocation}/${sectorSelected}/${nextPage}`)
        .then(response => {
          setBusiness([...business, ...response.data.business])
          setNextPage(response.data.next_page)
        })

      setLoadingMoreBusiness(false)
    } catch {
      setLoadingMoreBusiness(false)
      toast.error("A busca falhou, tente novamente")
    }
  }

  async function fetchBusinessDatas(idSector) {
    const location = JSON.parse(localStorage.getItem('@Inoveclube:location')).idCity

    try {
      await api.get(`/getAllBusiness/${location}/${idSector}/1`)
        .then(response => {
          setBusiness(response.data.business)
          setNextPage(response.data.next_page)
        })

      setSectorSelected(idSector)
      setIsLoading(false)
    } catch {
      toast.error("A busca falhou, tente novamente")
    }
  }

  async function fetchSectors(location) {
    if (location === currentLocation) {
      setModalToFilterUserLocationOpen(false)
      return
    }

    setIsLoading(true)

    try {
      await api.get(`/getSectors/${location}`)
        .then(response => {
          setSectors(response.data)
          if (response.data.length > 0)
            fetchBusinessDatas(response.data[0].idSector)
          else
            setIsLoading(false)
        })

      setModalToFilterUserLocationOpen(false)
    } catch {
      toast.error("A busca falhou, tente novamente")
    }
  }
  
  useEffect(() => {
    document.getElementById("favicon").href = "https://inovesystem.s3.sa-east-1.amazonaws.com/favicon.ico"
    localStorage.removeItem('@Inoveclube:type')
    localStorage.removeItem('@Inoveclube:typeNumber')
  }, [])

  useEffect(() => {
    async function refetchSectors() {
      try {
        await api.get(`/getSectors/${currentLocation}`)
          .then(response => {
            setSectors(response.data)
            if (response.data.length > 0)
              fetchBusinessDatas(response.data[0].idSector)
            else
              setIsLoading(false)
          })

        setModalToFilterUserLocationOpen(false)
      } catch {
        toast.error("A busca falhou, tente novamente")
      }
    }

    if (currentLocation)
      refetchSectors()
  }, [currentLocation])



  if (isLoading)
    return <MainLoader title="Buscando empresas..." />


  return (
    <Container>
      {modalToFilterUserLocationOpen &&
        <ModalToFilterUserLocation
          fetchSectors={fetchSectors}
          setModalToFilterUserLocationOpen={setModalToFilterUserLocationOpen}
        />
      }

      {!modalToFilterUserLocationOpen &&
        <>
          <Header
            setModalToFilterUserLocationOpen={setModalToFilterUserLocationOpen}
          />

          <FirstSection />

          <Content>

            {
              !!sectors.length &&
              <SectorsAndBusiness
                sectors={sectors}
                business={business}
                fetchBusinessDatas={fetchBusinessDatas}
                fetchMoreBusiness={fetchMoreBusiness}
                loadingMoreBusiness={loadingMoreBusiness}
                nextPage={nextPage}
              />
            }

          </Content>
        </>
      }
    </Container>
  )
}
